import api from "../seller-apis/api";
import store from "../Store";
import { ActionTypes } from "./ActionTypes";
import { Actions } from "./Actions/index";
import { defaultAction } from "./Default";
import { updateSellerProfileOkStatus } from "./Profile";

let sellerMeInflight = null;

export async function loadSellerMeIfNeeded(dispatch) {
  const vr = store.getState().vendorDetailsReducer;
  if (vr.sellerMeLoaded && vr.sellerMeData) {
    Actions.upadteWalletAmount(dispatch, vr.sellerMeData?.wallet || []);
    Actions.updateBlockedVendorStatus(dispatch, vr.sellerMeData?.tmpStatus);
    if (vr.sellerMeMessage === "Seller Not Activated") {
      Actions.SellerVerified(dispatch, false);
    } else {
      Actions.SellerVerified(dispatch, true);
    }
    return { data: vr.sellerMeData, message: vr.sellerMeMessage };
  }
  if (sellerMeInflight) {
    return sellerMeInflight;
  }

  sellerMeInflight = (async () => {
    try {
      const res = await api.auth.me({});

      dispatch({
        type: ActionTypes.SELLER_ME_SUCCESS,
        payload: { data: res.data, message: res.message || "" },
      });

      defaultAction(dispatch, res.data?.avatar ?? localStorage.getItem("image"));

      Actions.upadteWalletAmount(dispatch, res?.data?.wallet || []);
      Actions.updateBlockedVendorStatus(dispatch, res?.data?.tmpStatus);
      if (res.message === "Seller Not Activated") {
        Actions.SellerVerified(dispatch, false);
      } else {
        Actions.SellerVerified(dispatch, true);
      }

      if (
        !("tanStatus" in res?.data) ||
        !("msmeStatus" in res?.data) ||
        !res?.data?.emailVerified ||
        !res?.data?.panNo ||
        !res?.data?.gstNo
      ) {
        updateSellerProfileOkStatus(dispatch, false);
      }

      return res;
    } finally {
      sellerMeInflight = null;
    }
  })();

  return sellerMeInflight;
}

export function resetSellerMe(dispatch) {
  dispatch({ type: ActionTypes.SELLER_ME_RESET });
}
